export default __webpack_public_path__ + "248d4db882b3c27006d030aac878b483.svg";